module.exports = __webpack_public_path__ + "img/pc-warning-small.8e1e7e1c.svg";